angular.module('ui.bootstrap',
       [
           'ui.bootstrap.modal',
           'ui.bootstrap.tabs',
           'ui.bootstrap.carousel',
           'ui.bootstrap.dropdown',
           'ui.bootstrap.typeahead',
           'ui.bootstrap.pagination'
       ]);